{
  "version": 1,
  "asset_id": "c2e89155-93ed-47b1-9f70-ffa586fdaf4c",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c2e89155-93ed-47b1-9f70-ffa586fdaf4c/floral-city-black-shingle-roof-installation-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c2e89155-93ed-47b1-9f70-ffa586fdaf4c/floral-city-black-shingle-roof-installation-768w.webp",
  "original_filename": "floral-city-black-shingle-roof-installation-768w.webp",
  "size": 51840,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
